import { CardSpendableUpdateModal } from '@/features/Cards/ui/CardSpendableUpdateModal/CardSpendableUpdateModal'
import { useModal } from '@/features/Modal/Modal.hooks'
import { DrawerModalAction } from '@/features/Modal/ui/DrawerModalAction/DrawerModalAction'
import { useCardsStore } from '@/store/cards/cards'
import React, { useCallback } from 'react'
import { createCardsQueryOptions } from '@/features/Cards/queries'
import { useQuery } from '@tanstack/react-query'

export function CardSpendableModal() {
  const { destroyModal, createModal } = useModal()
  const card = useCardsStore((state) => state.selectedCard)
  const { data:cards } = useQuery(createCardsQueryOptions())

  const selectedCard = cards?.find((c) => c.id === card)

  const onCancel = useCallback(() => {
    destroyModal()
  }, [destroyModal])

  const handleUpdate = useCallback(() => {
    createModal(<CardSpendableUpdateModal tokenAddress={selectedCard.tokenAddress} cryptoBalance={selectedCard.balance} />)
  }, [selectedCard, createModal])

  return (
    <DrawerModalAction
      cancelOnClick={onCancel}
      cancelTitle="Got it"
      confirmOnClick={handleUpdate}
      confirmTitle="Update"
      description="This is the balance you have entrusted for spending in the GoDefi app. Important, the balance is not updated, once it is exhausted, you need to specify and apply the approved amount for spending again"
      title="Spendable balance"
    />
  )
}
